export enum TaskViewType {
  FLAT = 'flat',
  TREE = 'tree',
}
